import { useContext } from "react";
import { LangContext } from "../../../contexts/langContext";
import { Txt } from "../Txt";


export function YoniLogo({ calcShown }) {
  const context = { ...useContext(LangContext) };
  const $ui = context.$ui;
  return (
    <div className="_fv _fgap1 yoni_page_content_inner">
    <div className="_f _fc _fm _fgap1">
      {/* <Logo /> */}
      <div className="yoni_page_logo">{$ui('settings_yoni_link')} (beta)</div>
    </div>

    <div className="yoni_page_title">
      {$ui('jyotish_yoni_label')}
    </div>

    <div className="yoni_page_description _tc">
      <Txt> 
        {$ui('jyotish_yoni_description')}
      </Txt>
    </div>

  </div>
  );
}